export const greenHue = 148;
export const orangeHue = 39;
export const violetHue = 278;